"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedWidthParser = void 0;
var splice_1 = require("./splice");
var date_fns_1 = require("date-fns");
var trimString_1 = require("./trimString");
var handleFalsyFallback_1 = require("./handleFalsyFallback");
var filterCharacters_1 = require("./filterCharacters");
var FixedWidthParser = /** @class */ (function () {
    /**
     * @param parseConfigMap Array of parse configs
     * @param options Additional options
     */
    function FixedWidthParser(parseConfigMap, options, logger) {
        if (logger === void 0) { logger = console; }
        var _this = this;
        var _a;
        this.logger = logger;
        this.parseLine = function (line, options) {
            return _this.parseConfigMap
                .map(function (config) { return ({
                config: config,
                rawString: line.slice(config.start, config.start + config.width),
            }); })
                .reduce(function (acc, curr) { return _this.parseLineSegments(acc, curr, options); }, {});
        };
        this.parseLineSegments = function (result, segment, options) {
            var _a;
            if (!segment.config.name) {
                return result;
            }
            return __assign(__assign({}, result), (_a = {}, _a[segment.config.name] = _this.parseSegment(segment.config, segment.rawString, options), _a));
        };
        this.parseSegment = function (config, rawString, options) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            var filteredString = (0, filterCharacters_1.filterCharacters)(rawString, _this.characterWhitelist);
            // Strip out padding
            var trimmedString = (0, trimString_1.trimString)(filteredString, (_a = config.padChar) !== null && _a !== void 0 ? _a : ' ', (_b = config.padPosition) !== null && _b !== void 0 ? _b : 'start');
            // Parse remaining string
            switch (config.type) {
                case 'int': {
                    var value = void 0;
                    if (!config.radix || config.radix === 10) {
                        switch (config.mend) {
                            case 'ceil':
                                value = Math.ceil(parseFloat(trimmedString));
                                break;
                            case 'round':
                                value = Math.round(parseFloat(trimmedString));
                                break;
                            case 'error':
                                throw new Error("Expected parsed value for '".concat(config.name, "' to be an integer"));
                            case 'floor':
                            default:
                                value = parseInt(trimmedString);
                                break;
                        }
                    }
                    else {
                        value = parseInt(trimmedString, config.radix);
                    }
                    return (0, handleFalsyFallback_1.handleFalsyFallback)(value, (_c = config.falsyFallback) !== null && _c !== void 0 ? _c : options.falsyFallback);
                }
                case 'float': {
                    var decimalCount = (_d = config.decimalCount) !== null && _d !== void 0 ? _d : 2;
                    if (trimmedString.includes('.')) {
                        return (0, handleFalsyFallback_1.handleFalsyFallback)(Number(trimmedString), (_e = config.falsyFallback) !== null && _e !== void 0 ? _e : options.falsyFallback);
                    }
                    // Pad to original field width with 0's to ensure decimal can be injected
                    var stringToParse = trimmedString.padStart(config.width, '0');
                    return (0, handleFalsyFallback_1.handleFalsyFallback)(Number((0, splice_1.splice)(stringToParse, '.', stringToParse.length - 1 - decimalCount)), (_f = config.falsyFallback) !== null && _f !== void 0 ? _f : options.falsyFallback);
                }
                case 'bool': {
                    if (trimmedString === config.trueValue) {
                        return true;
                    }
                    if (trimmedString === config.falseValue) {
                        return false;
                    }
                    _this.logger.warn("Failed to parse to boolean value. Falling back to ".concat(options.falsyFallback, "."));
                    return (0, handleFalsyFallback_1.handleFalsyFallback)(false, (_g = config.falsyFallback) !== null && _g !== void 0 ? _g : options.falsyFallback);
                }
                case 'date': {
                    var parsedDate = (0, date_fns_1.parse)(trimmedString, config.fixedWidthFormat, new Date());
                    if ((0, date_fns_1.isValid)(parsedDate)) {
                        return (0, date_fns_1.format)(parsedDate, config.jsonFormat);
                    }
                    if (config.tryParsingRawValueBeforeFallback) {
                        var parsedRawDate = (0, date_fns_1.parse)(rawString, config.fixedWidthFormat, new Date());
                        if ((0, date_fns_1.isValid)(parsedRawDate)) {
                            return (0, date_fns_1.format)(parsedRawDate, config.jsonFormat);
                        }
                    }
                    var failValue = void 0;
                    if (config.falsyFallback === 'passthrough') {
                        failValue = trimmedString;
                    }
                    else {
                        failValue = (0, handleFalsyFallback_1.handleFalsyFallback)(null, (_h = config.falsyFallback) !== null && _h !== void 0 ? _h : options.falsyFallback);
                    }
                    _this.logger.warn("Failed to parse to date value. Falling back to ".concat(failValue, "."));
                    return failValue;
                }
                case 'skip': {
                    // handle skip with a name
                    return undefined;
                }
                case 'string':
                default: {
                    // TODO: Find a good way to warn of untrimmed values as they may indicate a misconfiguration
                    return (0, handleFalsyFallback_1.handleFalsyFallback)(trimmedString, (_j = config.falsyFallback) !== null && _j !== void 0 ? _j : options.falsyFallback);
                }
            }
        };
        this.applyDefaultType = function (parseConfig) {
            if (!parseConfig.type) {
                parseConfig.type = 'string';
            }
            return parseConfig;
        };
        this.validateParseConfigs = function (parseConfig, index) {
            var _a;
            var errorResponse = {
                index: index,
                config: parseConfig,
                errors: [],
            };
            if (parseConfig.width === undefined || parseConfig.width === null || parseConfig.width <= 0) {
                errorResponse.errors.push("Width must be greater than zero.");
            }
            if (parseConfig.start === undefined || parseConfig.start === null) {
                errorResponse.errors.push("Start must be defined.");
            }
            if (((_a = parseConfig.padChar) === null || _a === void 0 ? void 0 : _a.length) > 1) {
                errorResponse.errors.push("padChar can only be a single character.");
            }
            if (parseConfig.default && parseConfig.default.toString().length > parseConfig.width) {
                errorResponse.errors.push("Default value will not fit in the specified width.");
            }
            switch (parseConfig.type) {
                case 'int':
                case 'float':
                    if (/[1-9]/.test(parseConfig.padChar)) {
                        errorResponse.errors.push("Cannot pad numbers with numbers other than '0'.");
                    }
                    if (parseConfig.padPosition === 'end') {
                        errorResponse.errors.push("Cannot pad the end of numbers.");
                    }
                    if (parseConfig.type === 'float' && parseConfig.decimalCount > parseConfig.width) {
                        errorResponse.errors.push("Cannot have '".concat(parseConfig.decimalCount, "' decimals when field is only '").concat(parseConfig.width, "' char wide."));
                    }
                    if (parseConfig.type === 'int' &&
                        parseConfig.radix &&
                        parseConfig.radix !== 10 &&
                        parseConfig.mend &&
                        parseConfig.mend !== 'error') {
                        errorResponse.errors.push("Cannot have a radix of '".concat(parseConfig.radix, " with any sort of rounding solution."));
                    }
                    break;
                case 'bool':
                    // TODO: Check paddingChar against true/false values?
                    if (!parseConfig.trueValue) {
                        errorResponse.errors.push("Missing property 'trueValue'.");
                    }
                    if (!parseConfig.falseValue) {
                        errorResponse.errors.push("Missing property 'falseValue'.");
                    }
                    break;
                case 'date':
                    if (!parseConfig.fixedWidthFormat) {
                        errorResponse.errors.push("Missing property 'fixedWidthFormat'.");
                    }
                    if (!parseConfig.jsonFormat) {
                        errorResponse.errors.push("Missing property 'jsonFormat'.");
                    }
                    break;
            }
            if (errorResponse.errors.length > 0) {
                return errorResponse;
            }
        };
        if (parseConfigMap.length <= 0) {
            throw new Error("Invalid parse config! Parse config is empty!");
        }
        this.parseConfigMap = parseConfigMap
            .sort(function (a, b) { return a.start - b.start; })
            .map(this.applyDefaultType);
        var validationErrors = this.parseConfigMap
            .map(this.validateParseConfigs)
            .filter(function (err) { return err !== undefined; });
        if (validationErrors.length > 0) {
            throw validationErrors;
        }
        this.fullWidth = this.parseConfigMap.reduce(function (prev, next) { return prev + next.width; }, 0);
        if ((options === null || options === void 0 ? void 0 : options.expectedFullWidth) && this.fullWidth !== options.expectedFullWidth) {
            throw new Error("Calculated full width (".concat(this.fullWidth, ") does not match asserted full width (").concat(options.expectedFullWidth, ")!"));
        }
        this.defaults = {
            truncate: (_a = options === null || options === void 0 ? void 0 : options.truncate) !== null && _a !== void 0 ? _a : true,
        };
        this.characterWhitelist = options === null || options === void 0 ? void 0 : options.characterWhitelist;
    }
    FixedWidthParser.prototype.parse = function (input, options) {
        var _this = this;
        options = __assign({ falsyFallback: 'passthrough' }, options);
        if (!input) {
            throw new Error('Invalid input! Input is empty!');
        }
        if (typeof input !== 'string') {
            throw new Error("Invalid input! Input must be a string!");
        }
        var lines = input.replace(/\r\n/g, '\n').split('\n');
        return lines.map(function (line) { return _this.parseLine(line, options); });
    };
    FixedWidthParser.prototype.unparse = function (input) {
        var _this = this;
        if (!input || input.length <= 0) {
            throw new Error('Invalid input! Input is empty!');
        }
        var lines = input.map(function (record) {
            var _a, _b, _c, _d, _e, _f, _g;
            var line = '';
            for (var _i = 0, _h = _this.parseConfigMap; _i < _h.length; _i++) {
                var config = _h[_i];
                var value = '';
                if (record[config.name] === undefined || record[config.name] === null) {
                    value = '';
                }
                else {
                    // Handle type specific conversion
                    switch (config.type) {
                        case 'float': {
                            var numAsStr = record[config.name].toString();
                            // If the value not longer contains a decimal point
                            // (123.00 -> 123) assume the decimal point should be at the end.
                            var decimalIndex = numAsStr.indexOf('.') > -1 ? numAsStr.indexOf('.') : numAsStr.length;
                            var strippedDecimals = numAsStr.slice(0, decimalIndex + ((_a = config.decimalCount) !== null && _a !== void 0 ? _a : 2) + 1);
                            // Add expected decimal places
                            var currentDecimals = strippedDecimals.indexOf('.') > -1
                                ? strippedDecimals.slice(strippedDecimals.indexOf('.') + 1).length
                                : 0;
                            if (config.decimalCount > currentDecimals) {
                                var decimalsNeeded = config.decimalCount - currentDecimals;
                                strippedDecimals = strippedDecimals.padEnd(strippedDecimals.length + decimalsNeeded, '0');
                            }
                            value =
                                ((_b = config.insertDecimal) !== null && _b !== void 0 ? _b : true)
                                    ? strippedDecimals
                                    : strippedDecimals.replace(/\./g, '');
                            break;
                        }
                        case 'int':
                            // Don't assume that the value is an int.
                            switch (config.mend) {
                                case 'ceil':
                                    value = Math.ceil(record[config.name]).toString(10);
                                    break;
                                case 'round':
                                    value = Math.round(record[config.name]).toString(10);
                                    break;
                                case 'error':
                                    throw new Error("Expected parsed value for '".concat(config.name, "' to be an integer"));
                                case 'floor':
                                default:
                                    value = Math.floor(record[config.name]).toString((_c = config.radix) !== null && _c !== void 0 ? _c : 10);
                                    break;
                            }
                            break;
                        case 'string':
                            value = String(record[config.name]);
                            break;
                        case 'bool':
                            value = record[config.name] ? config.trueValue : config.falseValue;
                            break;
                        case 'date': {
                            var parsedDate = (0, date_fns_1.parse)(String(record[config.name]), config.jsonFormat, new Date());
                            if ((0, date_fns_1.isValid)(parsedDate)) {
                                value = (0, date_fns_1.format)(parsedDate, config.fixedWidthFormat);
                            }
                            break;
                        }
                    }
                }
                // Handle default value
                if (!value && config.default !== undefined) {
                    value = String(config.default);
                }
                // Handle padding
                if (((_d = config.padPosition) !== null && _d !== void 0 ? _d : 'start') === 'start') {
                    value = value.padStart(config.width, (_e = config.padChar) !== null && _e !== void 0 ? _e : ' ');
                }
                else {
                    value = value.padEnd(config.width, (_f = config.padChar) !== null && _f !== void 0 ? _f : ' ');
                }
                // Handle truncate or error
                if (value.length > config.width) {
                    // Prioritize config-level option over parser-level options
                    if (!((_g = config.truncate) !== null && _g !== void 0 ? _g : _this.defaults.truncate)) {
                        throw new Error("Unable to parse value '".concat(value, "' into width of '").concat(config.width, "' for field '").concat(config.name, "'!"));
                    }
                    _this.logger.warn("Truncating value '".concat(value, "' to '").concat(value.slice(0, config.width), "' to fit in '").concat(config.name, "' width of '").concat(config.width, "'."));
                    value = value.slice(0, config.width);
                }
                // Append value to current line
                line += value;
            }
            return line;
        });
        return lines.join('\n');
    };
    return FixedWidthParser;
}());
exports.FixedWidthParser = FixedWidthParser;
